import m from 'mithril';
import { BookingDetail, BookingLookupOTP, InitialConfigurationData, Location } from '../../Models';
import { SubFsm } from 'little-fsm';
import FindBookingPage from '../../components/common/findbooking/FindBookingPage';
import { BookingLookupResultState } from '../../states/BookingSearchFormState';
import BookingSearchCriteria from '../../states/BookingSearchCriteria';
import OtpFormPage from '../../components/desktop/otp/OtpFormPage';
import { AppComponents } from '../../app_common_setup';
import { FindBookingSubManifest } from '../../states/app_desktop_root';
import { CalendarDialog, Dialog } from '../../components/common/MaterialDesignComponents';
import LocationFilterListComponent from '../../components/common/location/LocationFilterListComponent';
import DateRangePicker from '../../components/common/datepicker/DateRangePicker';
import dayjs from 'dayjs';
import BookingConfirmationComponent from '../../components/mobile/confirmation/BookingConfirmationComponent';

let bookings: BookingDetail[] = [];
let bookingLookupResultState: BookingLookupResultState = 'START_SHOW_FORM';
let bookingLookupOTP:BookingLookupOTP|null = null;
let otp: string = '';
let isShowingLocationSelectionDialog = false;
let isShowingDateSelectionDialog = false;
let startYear = dayjs().year();
let startMonth = dayjs().month() - 2;

export function buildFindBookingPresenter(subFsm:SubFsm<FindBookingSubManifest>, appComponents:AppComponents, initialConfigData:InitialConfigurationData): {render:() => m.Vnode<any,any>} {
    let dataSource = appComponents.dataSource;
    let agentId = appComponents.branding.agentId;
    let customerSupportInfo = appComponents.customerSupport;
    let messageProvider = appComponents.messageProvider;

    subFsm.setEnterEffect('searching_booking', ctx => {
        let searchCriteria = ctx.bookingSearchFormState.toBookingSearchCriteria();
        dataSource.apiClient.sentBookingLookupOtp(searchCriteria.getLocation().id, searchCriteria.getCheckInDate(), searchCriteria.getCheckOutDate(),
            searchCriteria.getEmail(), searchCriteria.getPhoneNumber())
        .then(result => {   
            if(result.isSuccess()){                        
                bookingLookupOTP = result.getBody();
                bookingLookupResultState = 'READY_TO_SENT_OTP';     
                subFsm.processEvent('search_booking_successed', {})
            }else{
                bookingLookupResultState = 'NO_RELATED_BOOKING';
                subFsm.processEvent('search_booking_failed', {})
            } 
        });
    })

    subFsm.setEnterEffect('resending_otp', ctx => {
        let searchCriteria = ctx.bookingSearchFormState.toBookingSearchCriteria();
        dataSource.apiClient.sentBookingLookupOtp(searchCriteria.getLocation().id, searchCriteria.getCheckInDate(), searchCriteria.getCheckOutDate(),
            searchCriteria.getEmail(), searchCriteria.getPhoneNumber())
        .then(result => {   
            if(result.isSuccess()){                        
                bookingLookupOTP = result.getBody();
                bookingLookupResultState = 'READY_TO_SENT_OTP';     
                subFsm.processEvent('search_booking_successed', {})
            }else{
                bookingLookupResultState = 'NO_RELATED_BOOKING';
                subFsm.processEvent('search_booking_failed', {})
            } 
        });
    })

    subFsm.setEnterEffect('checking_otp', ctx => {
        if(bookingLookupOTP?.otp == otp && ctx.bookingSearchFormState.toBookingSearchCriteria() != null){
            bookingLookupResultState = 'SHOW_RESULT'; 
            dataSource.apiClient.getBookingLookup(ctx.bookingSearchFormState.toBookingSearchCriteria(), null)
            .then(result => {
                bookings = result;
                subFsm.processEvent('otp_corrected', {})
            })
        }else{
            bookingLookupResultState = 'INCORRECT_OTP';
            subFsm.processEvent('otp_wrong', {})
        }
    })

    return {
        render() {
            let substate = subFsm.getCurrentSubState();
            let context = subFsm.getCurrentContext();

            if(substate == 'initial' || substate == 'searching_booking' || substate == 'selecting_location' || substate == 'selecting_date_range'){
                return m("div", [
                    m(FindBookingPage, {
                        bookings: bookings,
                        locations : initialConfigData.locations,
                        messageProvider: messageProvider,
                        bookingSearchFormState: context.bookingSearchFormState,
                        bookingLookupResultState: bookingLookupResultState,
                        isMobile: false,
                        onSearch: (criteria: BookingSearchCriteria) => {
                            subFsm.processEvent('search_booking_requested', {
                                searchCriteria: criteria
                            })
                        },
                        onViewDetails: (selectedBooking: BookingDetail) => {
                            subFsm.processEvent('booking_details_requested', {
                                booking: selectedBooking
                            })
                        },
                        onLocationClick: () => {
                            isShowingLocationSelectionDialog = true;
                            subFsm.processEvent('location_requested', {})
                        },
                        onDateRangePickerClick: () => {
                            isShowingDateSelectionDialog = true;
                            subFsm.processEvent('date_range_requested', {})
                        }
                    }),

                    m(Dialog, {
                        "title": "Select Location",
                        isOnDesktop: true,
                        isOpen: isShowingLocationSelectionDialog,
                        onClose : () => {
                            isShowingLocationSelectionDialog = false;
                        },
                        actionItems : [
                            {
                                label: "Close",
                                onclick: () => {
                                    isShowingLocationSelectionDialog = false;
                                }
                            }
                        ],
                        isLocationDialog: true,
                    }, [
                        m(LocationFilterListComponent, {
                            messageProvider : messageProvider,
                            locations : initialConfigData.locations,
                            isShowAttraction: false,
                            onLocationSelected: (location: Location) => {
                                isShowingLocationSelectionDialog = false;
                                subFsm.processEvent('location_selected', {
                                    selectedLocation: location
                                })
                            }
                        })
                    ]),
    
                    m(CalendarDialog, {
                        "title": "Select Date",
                        showCloseIcon: true,
                        isOnDesktop: true,
                        isOpen: isShowingDateSelectionDialog,
                        onClose : () => {
                            isShowingDateSelectionDialog = false;
                        },
                        actionItems : [
                            {
                                label: "Close",
                                onclick: () => {
                                    isShowingDateSelectionDialog = false;
                                }
                            }
                        ]
                    }, [
                        m(DateRangePicker, {
                            startYear: startYear,
                            startMonth: startMonth,
                            selectedDateRange: {
                                startDate: context.bookingSearchFormState.checkInDate,
                                endDate: context.bookingSearchFormState.checkOutDate
                            },
                            startLabel: messageProvider.get("checkin_date"),
                            endLabel: messageProvider.get("checkout_date"),
                            applyButtonLabel: messageProvider.get("apply_dates"),
                            maxRange: 13,
                            numberOfMonth: 12,                
                            isOnDesktop: true,
                            onDateRangeSelected: (startDate, endDate) => {
                                console.log("date range set ", startDate, endDate)
                                subFsm.processEvent('date_range_selected', {
                                    checkInDate: startDate,
                                    checkOutDate: endDate
                                })
                                isShowingDateSelectionDialog = false;                 
                            }
                        })
                    ])
                ])
            } else if(substate == 'showing_otp_form' || substate == 'resending_otp' || substate == 'checking_otp') {
                return m(OtpFormPage, {
                    bookingLookupResultState: bookingLookupResultState,
                    messageProvider: messageProvider,
                    emailOrPhone: (context.bookingSearchFormState.toBookingSearchCriteria().getEmail() != null)? context.bookingSearchFormState.toBookingSearchCriteria().getEmail(): context.bookingSearchFormState.toBookingSearchCriteria().getPhoneNumber(),
                    onSubmit: (otpValue: string) => {
                        otp = otpValue;
                        subFsm.processEvent('otp_submitted', {})
                    },
                    onResentOtp: () => {
                        subFsm.processEvent('otp_resend_requested', {})
                    }
                })
            } else if(substate == 'booking_details'){
                return m(BookingConfirmationComponent, {
                        agentId: agentId,
                        hotLineNumber: customerSupportInfo.hotLineNumber,
                        messageProvider: messageProvider,
                        booking: context.bookingDetails!
                    })
            } else {
                return m("div", "Not Defined");
            }
        }
    }
}